import { Box, Divider } from '@shopify/polaris';
import { HeaderTitle } from './component/HeaderTitle';
import { LabelButton } from './component/LabelButton';
import { RequireCondition } from './component/RequireCondition';
import { ErrorMessage } from './component/ErrorMessage';
import { AdditionalMessage } from './component/AdditionalMessage';

export const ShippingText = () => {
  return (
    <Box>
      <HeaderTitle />
      <Box paddingBlock={'200'}>
        <Divider />
      </Box>
      <LabelButton />
      <Box paddingBlock={'200'}>
        <Divider />
      </Box>
      <RequireCondition />
      <Box paddingBlock={'200'}>
        <Divider />
      </Box>
      <ErrorMessage />
      <Box paddingBlock={'200'}>
        <Divider />
      </Box>
      <AdditionalMessage />
    </Box>
  );
};
